<template>
	<div class="tp" role="radiogroup" aria-label="Tema del sito">
		<button
			v-for="p in preset"
			:key="p.code"
			type="button"
			role="radio"
			:aria-checked="p.code === value ? 'true' : 'false'"
			:disabled="!p.attivo"
			class="tp-card"
			:class="{ 'tp-card--on': p.code === value, 'tp-card--off': !p.attivo }"
			@click="$emit('input', p.code)"
		>
			<!-- anteprima schematica della home della variante -->
			<div class="tp-preview" :class="`tp-preview--${p.code}`" aria-hidden="true">
				<template v-if="p.code === 'bazaar'">
					<div class="tp-bar tp-bar--dark"><span class="tp-logo"></span><span class="tp-search tp-search--wide"></span><span class="tp-icons"></span></div>
					<div class="tp-catrow"></div>
					<div class="tp-row">
						<div class="tp-side"></div>
						<div class="tp-hero tp-hero--short"></div>
						<div class="tp-promo"></div>
					</div>
					<div class="tp-grid tp-grid--6"><span v-for="n in 12" :key="n"></span></div>
				</template>
				<template v-else-if="p.code === 'boutique'">
					<div class="tp-strip"></div>
					<div class="tp-bar tp-bar--light"><span class="tp-logo"></span><span class="tp-search"></span><span class="tp-icons"></span></div>
					<div class="tp-catrow tp-catrow--thin"></div>
					<div class="tp-row">
						<div class="tp-hero tp-hero--text"></div>
						<div class="tp-hero tp-hero--photo"></div>
					</div>
					<div class="tp-grid tp-grid--4 tp-grid--tall"><span v-for="n in 4" :key="n"></span></div>
				</template>
				<template v-else-if="p.code === 'forge'">
					<div class="tp-strip"></div>
					<div class="tp-bar tp-bar--light"><span class="tp-logo"></span><span class="tp-search tp-search--wide"></span><span class="tp-icons"></span></div>
					<div class="tp-catrow"></div>
					<div class="tp-row">
						<div class="tp-hero"></div>
						<div class="tp-col"><span></span><span></span></div>
					</div>
					<div class="tp-grid tp-grid--4"><span v-for="n in 8" :key="n"></span></div>
				</template>
				<template v-else-if="p.code === 'breeze'">
					<div class="tp-bar tp-bar--light"><span class="tp-menu"></span><span class="tp-logo tp-logo--center"></span><span class="tp-icons"></span></div>
					<div class="tp-hero tp-hero--tall"></div>
					<div class="tp-grid tp-grid--3"><span v-for="n in 3" :key="n"></span></div>
				</template>
				<template v-else>
					<div class="tp-strip"></div>
					<div class="tp-bar"><span class="tp-logo"></span><span class="tp-search"></span><span class="tp-icons"></span></div>
					<div class="tp-row">
						<div class="tp-hero"></div>
						<div class="tp-col"><span></span><span></span></div>
					</div>
					<div class="tp-grid tp-grid--4"><span v-for="n in 8" :key="n"></span></div>
				</template>
			</div>
			<div class="tp-body">
				<div class="tp-name">
					<v-icon small :color="p.code === value ? 'primary' : 'grey'" class="mr-1">{{ p.code === value ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}</v-icon>
					{{ p.label }}
					<span v-if="!p.attivo" class="tp-badge">In arrivo</span>
					<span v-else-if="p.code === value && personalizzato" class="tp-badge tp-badge--info">Personalizzato</span>
				</div>
				<div class="tp-desc">{{ p.descrizione }}</div>
			</div>
		</button>
	</div>
</template>

<script>
// scelta del tema del sito: ogni preset imposta in un colpo header, footer, home, categoria e card prodotto
export default {
	name: 'TemaPreset',
	props: {
		value: { type: String, default: 'harvest' },
		// [{ code, label, descrizione, attivo }]
		preset: { type: Array, default: () => [] },
		// qualche area e' stata cambiata in "Avanzate" rispetto al preset
		personalizzato: { type: Boolean, default: false },
	},
};
</script>

<style scoped>
.tp {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
	gap: 12px;
}
.tp-card {
	display: flex;
	flex-direction: column;
	padding: 0;
	border: 1px solid #e1e7ef;
	border-radius: 10px;
	background: #fff;
	text-align: left;
	cursor: pointer;
	overflow: hidden;
	transition: border-color 0.15s, box-shadow 0.15s;
}
.tp-card:hover:not(:disabled) {
	border-color: #9fb6d3;
}
.tp-card--on {
	border-color: #01579b;
	box-shadow: 0 0 0 1px #01579b;
}
.tp-card--off {
	cursor: not-allowed;
}
.tp-card--off .tp-preview {
	opacity: 0.55;
}
.tp-card:focus-visible {
	outline: 2px solid #01579b;
	outline-offset: 2px;
}
.tp-body {
	padding: 10px 12px 12px;
}
.tp-name {
	display: flex;
	align-items: center;
	font-size: 14px;
	font-weight: 600;
	color: #1f2d3d;
}
.tp-desc {
	margin-top: 4px;
	font-size: 12px;
	line-height: 1.4;
	color: #5b6b7f;
}
.tp-badge {
	margin-left: auto;
	padding: 1px 8px;
	border-radius: 10px;
	background: #eef2f7;
	font-size: 11px;
	font-weight: 600;
	color: #5b6b7f;
}
.tp-badge--info {
	background: #eef4fd;
	color: #01579b;
}

/* anteprime: solo forme, nei colori neutri del BO */
.tp-preview {
	display: flex;
	flex-direction: column;
	gap: 4px;
	height: 128px;
	padding: 8px;
	background: #f5f7fa;
	border-bottom: 1px solid #eef2f7;
}
.tp-strip {
	height: 5px;
	border-radius: 2px;
	background: #c98b5e;
}
.tp-bar {
	display: flex;
	align-items: center;
	gap: 6px;
	height: 14px;
	padding: 0 4px;
	border-radius: 3px;
	background: #fff;
}
.tp-bar--dark {
	background: #3b4a5c;
}
.tp-bar--light {
	justify-content: space-between;
}
.tp-logo {
	width: 18px;
	height: 6px;
	border-radius: 2px;
	background: #9aa8b8;
}
.tp-bar--dark .tp-logo,
.tp-bar--dark .tp-icons {
	background: #c7d1dc;
}
.tp-search {
	flex: 1;
	height: 6px;
	border-radius: 3px;
	background: #e3e8ee;
}
.tp-search--wide {
	background: #fff;
}
.tp-menu {
	width: 10px;
	height: 6px;
	border-radius: 2px;
	background: #c7d1dc;
}
.tp-icons {
	width: 16px;
	height: 6px;
	border-radius: 2px;
	background: #c7d1dc;
}
.tp-catrow {
	height: 6px;
	border-radius: 2px;
	background: #dfe5ec;
}
.tp-row {
	display: flex;
	gap: 4px;
	height: 40px;
}
.tp-hero {
	flex: 1;
	border-radius: 3px;
	background: #c9d3de;
}
.tp-hero--tall {
	flex: none;
	height: 56px;
}
.tp-hero--short {
	flex: 1.4;
}
.tp-col {
	display: flex;
	flex-direction: column;
	gap: 4px;
	width: 30%;
}
.tp-col span {
	flex: 1;
	border-radius: 3px;
	background: #e3c9b5;
}
.tp-side {
	width: 22%;
	border-radius: 3px;
	background: #fff;
}
.tp-promo {
	width: 22%;
	border-radius: 3px;
	background: #dfe5ec;
}
.tp-grid {
	display: grid;
	gap: 3px;
	flex: 1;
}
.tp-grid span {
	border-radius: 2px;
	background: #fff;
}
.tp-grid--3 {
	grid-template-columns: repeat(3, 1fr);
	gap: 6px;
}
.tp-grid--4 {
	grid-template-columns: repeat(4, 1fr);
}
.tp-grid--6 {
	grid-template-columns: repeat(6, 1fr);
	gap: 2px;
}
/* boutique: menu sottile centrato, apertura testo + foto, card verticali */
.tp-preview--boutique {
	background: #f8f6f1;
}
.tp-preview--boutique .tp-strip {
	background: #00733a;
}
.tp-catrow--thin {
	height: 3px;
	margin: 0 25%;
}
.tp-hero--text {
	background: #ece7de;
}
.tp-hero--photo {
	background: #c9bfae;
}
.tp-grid--tall span {
	min-height: 22px;
	background: #ece7de;
}
/* forge: barra servizi e menu antracite con il bordo giallo, ricerca larga, angoli squadrati */
.tp-preview--forge {
	background: #eeeeea;
}
.tp-preview--forge .tp-strip {
	background: #16181b;
}
.tp-preview--forge .tp-catrow {
	background: #2a2e34;
	border-bottom: 2px solid #ffd200;
}
.tp-preview--forge .tp-search {
	background: #fff;
	box-shadow: inset 0 0 0 1px #16181b, inset -10px 0 0 #ca0000;
}
.tp-preview--forge .tp-hero {
	background: #c9cbc6;
}
.tp-preview--forge .tp-col span:first-child {
	background: #16181b;
}
.tp-preview--forge .tp-col span:last-child {
	background: #ffd200;
}
.tp-preview--forge .tp-hero,
.tp-preview--forge .tp-col span,
.tp-preview--forge .tp-grid span,
.tp-preview--forge .tp-search {
	border-radius: 0;
}
</style>
